import { useState } from "react";
import type { IResendEmailFormProps } from "@b2bportal/core-self-serve/overridable";
import { Button, ButtonTypeEnum, InputText } from "@tenant/ui";
export interface ResendEmailFormProps extends IResendEmailFormProps {
  initialValue?: string;
}

export const ResendEmailForm = ({
  cn,
  copy,
  resendEmail,
  initialValue = "",
}: ResendEmailFormProps) => {
  const [email, setEmail] = useState(initialValue);

  return (
    <div className={cn("modal-content", ["email-form"])}>
      <div className={cn("modal-body")}>
        <div className={cn("resend-form")}>
          <InputText
            required
            className={cn("email-address-input")}
            label={copy.emailForm.inputLabel}
            onChange={(evt) => setEmail(evt.target.value)}
            type="email"
            autoComplete="email"
            value={email}
            floatingLabel={false}
          />
        </div>
      </div>
      <div className={cn("modal-footer")}>
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={cn("submit-btn")}
          disabled={!email}
          onClick={() => resendEmail(email)}
        >
          {copy.emailForm.submitBtn}
        </Button>
      </div>
    </div>
  );
};
